import React from "react";
import logo from "../Nav/img/Logo.jpg";
import {Columns, Table} from "react-bulma-components";
import PrintPartList from "./PrintPartList";



class PrintPartOrder extends React.Component {

    PartRow(part){
        let cost = Math.round(part.cost * 100) / 100
        let customerCost = Math.round(part.customer_cost * 100) / 100
        return (
            <tr>
                <td>{part.name}</td>
                <td>{part.part_number}</td>
                <td>{part.supplier ? part.supplier.display_name : ""}</td>
                <td>£{cost ?? 0}</td>
                <td>£{customerCost ?? 0}</td>
            </tr>
        )
    }


    render() {
        const partOrder = this.props.data;
        const parts = partOrder.parts;
        let totalCost = 0;
        let totalCustomerCost = 0;

        if(parts.length > 0){
            parts.forEach(part => {
                totalCost += part.cost;
                totalCustomerCost += part.customer_cost
            })
        }
        totalCost = Math.round(totalCost * 100) / 100
        totalCustomerCost = Math.round(totalCustomerCost * 100) / 100

        return (
            <div>
                <Columns>
                  <img src={logo} style={{width: '110px', height: '35px'}} alt="Rentals Direct Ltd" />
                  <h2 className="job-card-print-title">{`Part Order - ${partOrder ? partOrder.id : ""}`}</h2>
                </Columns>
                <br/>
                <Columns className={"page-break"}>
                    <Columns.Column>
                        <div>
                            <Table bordered>
                                <thead>
                                  <tr>
                                    <th>Customer</th>
                                    <th>Customer Order Number</th>
                                    <th>Total Cost</th>
                                    <th>Total Customer Cost</th>
                                    <th>Part Order Number</th>
                                  </tr>
                                </thead>
                                <tr>
                                  <td data-testid={"customer"}>{partOrder.customer ? partOrder.customer.display_name : ""}</td>
                                  <td data-testid={"order-number"}>{partOrder.order_number}</td>
                                  <td data-testid={"total-cost"}>{`£${totalCost}`}</td>
                                  <td data-testid={"total-customer-cost"}>{`£${totalCustomerCost}`}</td>
                                  <td data-testid={"part-order-number"}>{partOrder ? partOrder.id : ""}</td>
                                </tr>
                            </Table>
                            <Table
                                bordered
                            >
                                <thead>
                                    <tr>
                                        <th>Part Name</th>
                                        <th>Part Number</th>
                                        <th>Part Supplier</th>
                                        <th>Cost</th>
                                        <th>Customer Charge</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {parts.map(part => this.PartRow(part))}
                                </tbody>
                            </Table>
                        </div>
                    </Columns.Column>
                </Columns>
                <br/>
                <Columns>
                    <PrintPartList data={partOrder}/>
                </Columns>
            </div>
        )
    }

}
export default PrintPartOrder